<template>
  <div class="pb-4" style="background-color: white">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center py-5 px-5" style="border-bottom:#D6D5D5 solid 1px">
      <h1 class="mb-0" style="font-size:16px;font-weight:500">Tình hình học tập - {{className??''}}</h1>

    </div>
    <!--    body-->
    <div class="px-5 mt-5">
      <!-- Table -->
      <!-- Table -->
      <div class="" style="max-height: 650px;overflow-y: auto">
        <table class="table table-bordered table-hover text-nowrap">
          <thead class="thead-light " style="position: sticky;top: 0;background: #fff;z-index: 10;">
          <tr>
            <th>Học viên</th>
            <th>Số điện thoại</th>
            <th>Phân loại</th>
            <th>Trạng thái</th>
            <th>Năng lực</th>
            <th>Điểm danh</th>
            <th>Làm bài tập</th>
            <th>Kết quả thi gần nhất</th>
            <th class="text-center">Hành động</th>
          </tr>
          </thead>
          <tbody v-if="tableLoading">
          <tr>
            <td colspan="9" style="text-align: center"><span><i class="el-icon-loading"></i>
</span></td>
          </tr>
          </tbody>
          <tbody v-else-if="studentList.length === 0">
          <tr>
            <td colspan="9" style="text-align: center"><span>Không có dữ liệu</span></td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr v-for="(item, index) in studentList" :key="index">
            <!-- STT -->
            <td>{{ item.student }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.classification }}</td>

            <!-- Tình trạng (Status) -->
            <td>
              <button :class="getStatusClass(item.status)">
                {{ item.status }}
              </button>
            </td>

            <!-- Năng lực -->
            <td>{{ item.competency }}</td>

            <!-- Điểm danh -->
            <td>{{ item.attendance }}</td>

            <!-- Làm bài tập -->
            <td>{{ item.homework }}</td>

            <!-- Kết quả thi gần nhất + Tooltip -->
            <td>
              <el-tooltip v-if="item.examResult === 'Pass' || item.examResult==='Fail'" placement="right">
                <template   #content v-if="detailLoading" >
                  <div style="height: 100px;width: 200px" class="d-flex justify-content-center align-items-center">
                    <p  class="mb-0"><i class="el-icon-loading"></i></p>
                  </div>
                </template>

                <template #content v-else>
                  <div style="min-height: 100px;width: 200px">
                    <strong>Tổng điểm Overall: {{ item?.scoreDetails?.overall }}</strong><br>
                    • Listening: {{ item.scoreDetails?.listening }}<br>
                    • Speaking: {{ item.scoreDetails?.speaking }}<br>
                    • Reading: {{ item.scoreDetails?.reading }}<br>
                    • Writing: {{ item.scoreDetails?.writing }}<br>
                    • Vocab: {{ item.scoreDetails?.vocab || '-' }}<br>
                    <div v-if="item.examResult === 'Fail' && item.failReasons.length" class="mt-3">
                      <strong>Nguyên nhân fail khóa:</strong>
                      <div v-for="(reason, reasonIndex) in item.failReasons" :key="reasonIndex" class="mt-1">
                        <span style="color: red">•</span> {{ reason }}
                      </div>
                    </div>
                  </div>

                </template>

                <button :class="getResultClass(item.examResult)" @mouseenter="getScoreDetails(item,index)">
                  {{ item.examResult }}
                </button>
              </el-tooltip>

              <!-- Khi chưa thi -->
              <button v-else :class="getResultClass(item.examResult)">
                {{ item.examResult }}
              </button>
            </td>
            <td class="text-center">
              <button class="btn btn-xs btn-icon btn-outline-primary mr-2" @click="openDetailStudent(item)"><i
                  class="fa fa-eye"></i></button>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GET_DETAIL_RESULT_SITUATION,
  GET_LEARNING_SITUATION
} from "../../../../core/services/store/report-error/reportError.module";
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";

export default {
  name: "LearningSituation",
  components: {},
  data() {
    return {
      studentList: [],
      tableLoading: false,
      detailLoading: false,
      className: ''
    }
  },
  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Quản lý sản xuất", route: "" },
      { title: "Tình hình học tập" },
    ]);
    this.className = this.$route.query.className
    await this.getApiStudentList()

  },
  methods: {
    getLatestExamResult(student) {
      const finalResult = typeof student?.status_final === 'object'
        ? student.status_final?.is_pass
        : student?.status_final

      return finalResult && finalResult !== 'Chưa thi'
        ? finalResult
        : student?.status_midterm
    },
    async getApiStudentList() {
      this.tableLoading = true
      try {
        const IdClass = this.$route.params?.idClassroom
        const response = await this.$store.dispatch(GET_LEARNING_SITUATION, IdClass)
        this.studentList = response?.data?.map((student) => ({
          student: `${student.student_id + 100000} - ${student.student_name}`,
          phone: student.student_phone,
          classification: student.classification,
          status: student.status_class,
          competency: student.capacity_building,
          attendance: student.attendance,
          homework: student.mark_exam,
          examResult: this.getLatestExamResult(student),
          failReasons: student.status_final?.is_pass === 'Fail' && Array.isArray(student.status_final?.fail_reasons)
            ? student.status_final.fail_reasons
            : [],
          bestCustomerId: student?.best_customer_id,
          id: student?.student_id
        }))
      } catch (e) {
        this.studentList = []
      } finally {
        this.tableLoading = false
      }
    },
    async getScoreDetails(student, index) {
      if(this.studentList[index].scoreDetails)return
      this.detailLoading = true
      try {
        const response = await this.$store.dispatch(GET_DETAIL_RESULT_SITUATION, {
          classroom_id: this.$route.params.idClassroom,
          student_id: student?.id
        })
        const data = response?.data
        this.studentList[index].scoreDetails = {vocab:data?.vocabulary,writing:data?.writing,reading:data?.reading,speaking:data?.speaking,listening:data?.listening,overall:data?.overall}
      } catch (e) {

      } finally {
        this.detailLoading = false
      }
    },
    getStatusClass(status) {
      switch (status) {
        case 'Đang học':
          return 'btn btn-primary';   // xanh dương
        case 'Tạm nghỉ':
          return 'btn btn-warning';      // vàng/cam
        case 'Ngừng học':
          return 'btn btn-secondary';       // xám
        case 'Hoàn thành':
          return 'btn btn-success';       // xanh lá
        default:
          return 'btn btn-primary';
      }
    },
    getResultClass(result) {
      switch (result) {
        case 'Pass':
          return 'btn btn-success';       // xanh lá
        case 'Fail':
          return 'btn btn-danger';       // đỏ
        case 'Chưa thi':
          return 'btn btn-secondary';    // xám
        default:
          return 'btn btn-secondary';
      }
    },
    openDetailStudent(student) {
      const routeUrl = this.$router.resolve({path: `/customer-crm/detail/${student.id}?best_customer_id=${student.bestCustomerId}&active_name=cskh`}).href
      window.open(routeUrl, '_blank');
    }

  }
}
</script>

<style scoped>

</style>
